import type React from "react"

import { Icon, Message } from "semantic-ui-react"

import util from "utils/utils"

type AiWarningProps = {
  content: React.ReactNode
  includeDisclaimer?: boolean
}

const AiWarning = ({ content, includeDisclaimer = true }: AiWarningProps) => {
  return (
    <>
      <Message info color="purple" size="small">
        <Message.Header style={{ marginBottom: 10 }}>✨ AI-powered feature </Message.Header>
        {content}
        <span>
          {" "}
          <a
            href="https://support.simplydo.co.uk/hc/simplydo-help-center/articles/1754579836-ai-statement"
            target="_blank"
            style={{ textDecoration: "underline" }}
            rel="noopener"
          >
            Click here{" "}
          </a>
          {"  "}
          to read more about AI on {util.appName()}.
        </span>
      </Message>
      {includeDisclaimer && (
        <Message info icon size="small">
          <Icon name="info circle" />
          By proceeding, you acknowledge that AI-generated content is not guaranteed to be 100% accurate. Please
          remember to manually review the output.
        </Message>
      )}
    </>
  )
}

export default AiWarning
